// extracted by mini-css-extract-plugin
export default {"banner":"banner--lW44u","large":"large--Vu5Qy","visible":"visible--TBIyg","close-button":"close-button--DPPxX","closeButton":"close-button--DPPxX","blink":"blink--UrJij"};